import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import ExternalUploadFileComponent from "../components/external-upload-file/ExternalUploadFileComponent.vue";
import HomePage from "../components/Home.vue";

const routes: Array<RouteRecordRaw> = [
	{
		path: "/",
		name: "HomePage",
		component: HomePage
	},
	{
		path: "/upload-file",
		name: "ExternalUploadFileComponent",
		component: ExternalUploadFileComponent
	}
];

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes
});

export default router;
